export default __webpack_public_path__ + "static/media/telstra3.8f767073.jpg";